/* eslint-disable import/prefer-default-export */
import { getIdentityAndAccountParams } from '../helpers/account';
import { getAccountCollectionState } from '../helpers/bill';
import apiClient from '../middleware/apiClient';
import { CHANNEL_DATA } from '../helpers/apis';
import { COTTON_CHANNEL_DATA } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_CHANNEL_DATA = 'GET_CHANNEL_DATA';
export const GET_CHANNEL_DATA_SUCCESS = 'GET_CHANNEL_DATA_SUCCESS';
export const GET_CHANNEL_DATA_FAILURE = 'GET_CHANNEL_DATA_FAILURE';

export const STORE_ENHANCED_TRANSACTION_DATA = 'STORE_ENHANCED_TRANSACTION_DATA';

export const getChannelData = () => async (dispatch, getState) => {
  const { cpc: { promise, channelData } = {} } = getState();
  // Skip re-fetch if data is already loaded or a request is in-flight
  if (channelData || promise) return promise;

  const isCottonSession = getCottonSession();
  const endpoint = isCottonSession ? COTTON_CHANNEL_DATA : CHANNEL_DATA;

  try {
    const response = await dispatch({
      type: GET_CHANNEL_DATA,
      payload: apiClient.fetch(endpoint),
    }).payload;
    return dispatch({
      type: GET_CHANNEL_DATA_SUCCESS,
      payload: response,
    }).payload;
  } catch (error) {
    dispatch({
      type: GET_CHANNEL_DATA_FAILURE,
      payload: error,
    });
    throw error;
  }
};

const dispatchStoreEnhancedTransactionData = data => ({
  type: STORE_ENHANCED_TRANSACTION_DATA,
  payload: data,
});

// `data` = CPC payload (networkInfo + deviceFingerprintId); options carry API-selection flags.
export const storeEnhancedTransactionData = (
  data = {},
  {
    useContextHubApi = false,
    useBillDataApi = false,
    accountCollectionState,
  } = {},
) => (
  dispatch,
  getState,
) => {
  const {
    account: { indicators = {} } = {},
    contextHub: { contextHub: { infoIndicators = {} } = {} } = {},
    auth: { macaroon = {} } = {},
    bill: { delinquency = {} } = {},
  } = getState();

  const resolvedIndicators = useContextHubApi ? infoIndicators : indicators;

  const resolvedAccountCollectionState = useBillDataApi
    ? accountCollectionState
    : getAccountCollectionState(delinquency);

  const identityAndAccountData = getIdentityAndAccountParams(
    macaroon,
    resolvedAccountCollectionState,
  );
  const accountMdu = resolvedIndicators?.connectedBuildingIndicator?.status === 'TRUE';

  dispatch(dispatchStoreEnhancedTransactionData({
    ...identityAndAccountData,
    ...data,
    accountMdu,
  }));
};
